import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic } from 'helper/axios'
// import { string } from 'prop-types'

export const getResultCheckList = async ({ project_id, sprintflow_id, token }) => {
  // console.log(project_id, sprintflow_id)
  try {
    return await clientPublic
      .get(`checklist?project_id=${project_id}&sprintflow_id=${sprintflow_id}&limit=20`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const updateCheckList = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`checklist/${params.id}?project_id=${params.project_id}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const saveCheckList = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`checklist`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const deleteCheckList = async ({ params, token }) => {
  try {
    return await clientPublic
      .delete(`checklist/${params.id}?project_id=${params.project_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },

        data: params,
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const optionCheckList = async ({ token }) => {
  try {
    return await clientPublic
      .get(`optiontype?kind=task`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
